import React from "react";
import { Box, Tab, Tabs as GrommetTabs, ResponsiveContext, Heading } from "grommet";
import { Container } from "../Container";
export var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
    onUpdate = _ref.onUpdate;
  var size = React.useContext(ResponsiveContext);
  return /*#__PURE__*/ React.createElement(
    Container,
    null,
    /*#__PURE__*/ React.createElement(
      Box,
      {
        direction: "column",
        style: {
          width: "max-content",
          marginLeft: "auto",
          marginRight: "auto",
        },
      },
      /*#__PURE__*/ React.createElement(
        GrommetTabs,
        {
          onActive: onUpdate,
        },
        tabs.map(function (tab) {
          return /*#__PURE__*/ React.createElement(Tab, {
            margin: {
              bottom: size !== "small" ? "large" : "medium",
            },
            title: /*#__PURE__*/ React.createElement(
              Heading,
              {
                level: 4,
                color: "text",
                style: {
                  textTransform: "capitalize",
                },
              },
              tab.label
            ),
            key: tab.id,
          });
        })
      )
    )
  );
};
